<template>
  <main class="relative z-10 w-full bg-zinc-50">
    <FilterDialog
      ref="FilterDialog"
      :sort_type="sort_type"
      :category_product_data="category_product_data"
      :filter_year="filter_year"
      :category_data="available_category_data"
      :active_category_id="active_category_id"
      @change-sort="sort_type = $event"
      @update-year="filter_year = $event"
      :key_word="key_word"
      @update-keyword="key_word = $event"
    />
    <div class="relative w-full">
      <div class="flex items-start w-full px-5 py-10 pt-10 mx-auto md:px-10">
        <div class="hidden pr-5 w-96 lg:block">
          <div class="px-5">
            <BreadCrumb :path="breadcrumb" />
            <CategoryList
              :menu_category_data="menu_category_data"
              :category_data="available_category_data"
              :active_category_id="active_category_id"
              :category_product_data="category_product_data"
              :key_word="key_word"
              @update-keyword="key_word = $event"
            />
          </div>
        </div>

        <div class="flex-1 w-full">
          <div class="w-full mb-5 lg:flex lg:items-start lg:justify-end">
            <BreadCrumb :path="breadcrumb" class="block mb-3 lg:hidden" />
            <h2 class="block mb-3 text-xl font-light lg:hidden">
              {{
                active_category_id == "all"
                  ? "全部商品"
                  : available_category_data.find(
                      (item) => item.MenuID == active_category_id
                    ).Title
              }}
            </h2>

            <FilterBar
              :menu_category_data="menu_category_data"
              :category_data="available_category_data"
              :active_category="active_category_id"
              :category_product_data="category_product_data"
              @change-sort="sort_type = $event"
              @open-filter-dialog="() => $refs.FilterDialog.Open()"
            />
          </div>
          <EventTimer
            ref="EventTimer"
            :category_data="active_category_data"
            v-if="
              active_category_data && active_category_data.MenuTimeEnd != null
            "
          />

          <ol class="flex flex-wrap items-stretch -mx-3">
            <li
              class="flex-shrink-0 w-1/2 px-2 mb-5 xl:w-1/3 2xl:w-1/4"
              v-for="(item, item_index) in page_product_data"
              :key="`product_${item_index}`"
            >
              <ProductCard :ref="item.Title" :product_data="item" />
            </li>
          </ol>

          <Pagination
            :currentPage="page"
            :pagination="pagination_option"
            @pagechanged="ChangePage"
            class="mb-40"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb.vue";
import FilterBar from "@/components/productList/FilterBar.vue";
import CategoryList from "@/components/productList/CategoryList.vue";
import Pagination from "@/components/Pagination.vue";
import EventTimer from "@/components/scooterList/EventTimer.vue";
import ProductCard from "@/components/productList/ProductCard.vue";
import FilterDialog from "@/components/productList/FilterDialog.vue";
import { mapState } from "vuex";
import { getProductListData, getLowestPriceStock } from "@/common/data_convert";
import { GTM_ViewItemList } from "@/common/gtm_methods";
export default {
  name: "ProductListView",
  components: {
    BreadCrumb,
    FilterBar,
    CategoryList,
    Pagination,
    EventTimer,
    ProductCard,
    FilterDialog,
  },
  props: {
    window_size: {
      type: Number,
    },
  },
  data() {
    return {
      breadcrumb: [
        {
          title: "首頁",
          link: "/",
        },
        {
          title: "線上商店",
          link: "/collections",
        },
      ],
      page: 1,
      sort_type: "推薦排序",
      filter_year: [],
      key_word: "",
    };
  },
  methods: {
    CheckActiveCategory() {
      if (
        this.active_category_id != "all" &&
        this.active_category_data == null
      ) {
        this.$RedirectError();
      } else {
        const title =
          this.active_category_data != null
            ? this.active_category_data.Title
            : "線上商店";
        if (this.active_category_data != null) {
          this.$set(this.breadcrumb, 2, {
            title: title,
            link: "/scooters?category=" + this.active_category_data.MenuID,
          });
          GTM_ViewItemList(title, this.active_category_data.MenuID);
        } else {
          let breadcrumb = JSON.parse(JSON.stringify(this.breadcrumb));
          breadcrumb[2] ? breadcrumb.pop() : "";
          this.$set(this, "breadcrumb", breadcrumb);
          GTM_ViewItemList(title, "All");
        }

        const meta_data = this.$store.getters.page_meta_data("商品列表");
        this.$PageInit(
          this,
          title == "" ? meta_data.Title : title,
          meta_data.Content,
          meta_data.Image == "" ? "" : this.$ImageUrl(meta_data.Image)
        );
      }
    },
    ChangePage(page) {
      this.page = page;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    CheckTimer() {
      if (
        this.active_category_data &&
        this.active_category_data.MenuTimeEnd != null
      ) {
        this.$refs.EventTimer.SetTimer();
      }
    },
    GetProductSellStatus(product) {
      let totalStock = 0;
      if (product.IsCustom != "Y") {
        product.Stock.forEach((stock) => {
          if (stock.Status == "Y") {
            totalStock += parseInt(stock.Stock);
          }
        });
      } else {
        totalStock = product.CustomGoodsStock[0].Stock;
      }
      if (totalStock <= 0) {
        return "已售完";
      }

      if (product.GoodsTimeStart != null) {
        let startTime = new Date(product.GoodsTimeStart);
        let endTime = new Date(product.GoodsTimeEnd);
        let now = new Date();
        if (now < startTime) {
          return "尚未開賣";
        }
        if (now > endTime) {
          return "已結束販售";
        }
      }

      return "normal";
    },
  },
  watch: {
    $route() {
      this.page = 1;
      this.$nextTick(() => {
        this.CheckTimer();
        this.CheckActiveCategory();
      });
    },
  },
  computed: {
    ...mapState(["category_data"]),
    product_data() {
      if (this.$store.state.product_data == null) {
        return [];
      }
      let product_data = this.$store.state.product_data.filter((item) => {
        return (
          item.Menu.filter((menu) => {
            return (
              this.available_category_data.filter(
                (category) => category.MenuID == menu.MenuID
              ).length > 0
            );
          }).length > 0
        );
      });

      product_data = product_data.map((item) => {
        item.SellStatus = this.GetProductSellStatus(item);
        return item;
      });
      return product_data;
    },
    menu_category_data() {
      return this.$store.state.menu_category_data.filter(
        (item) => item.MenuCategoryID != 1
      );
    },
    available_category_data() {
      return this.category_data.filter(
        (item) =>
          item.Status == "Y" && item.Content7 == "Y" && item.MenuCategoryID != 1
      );
    },
    active_category_id() {
      return this.$route.query.category ? this.$route.query.category : "all";
    },
    active_category_data() {
      const category = this.category_data.filter(
        (item) =>
          item.MenuID == this.active_category_id && item.MenuCategoryID != 1
      );
      return category.length > 0 ? category[0] : null;
    },
    category_product_data() {
      let product_data = this.product_data.filter((product) => {
        const menu_count = product.Menu.filter((menu) => {
          return (
            this.available_category_data.filter(
              (category) => category["MenuID"] == menu["MenuID"]
            ).length > 0
          );
        });
        return menu_count.length > 0;
      });

      if (this.active_category_id != "all") {
        product_data = product_data.filter((product) => {
          return (
            product.Menu.filter((menu) => {
              return menu.MenuID == this.active_category_id;
            }).length > 0
          );
        });
      }
      // 如果有關鍵字
      if (this.key_word != "") {
        const key_word_list = this.key_word.split("");
        product_data = product_data.filter((item) => {
          return key_word_list.every((key_word) => {
            return (
              item.Title.toUpperCase().indexOf(key_word.toUpperCase()) != -1
            );
          });
        });
      }
      return product_data;
    },
    sort_product_data() {
      let product_list = this.category_product_data.slice();
      // 排序
      if (this.sort_type == "推薦排序") {
        product_list = product_list.sort((a, b) => {
          return a.Seq - b.Seq;
        });
      } else if (this.sort_type == "價錢由高到低") {
        product_list = product_list.sort((a, b) => {
          const StockA = getLowestPriceStock(a);
          const StockB = getLowestPriceStock(b);
          return parseInt(StockB.SellPrice) - parseInt(StockA.SellPrice);
        });
      } else if (this.sort_type == "價錢由低到高") {
        product_list = product_list.sort((a, b) => {
          const StockA = getLowestPriceStock(a);
          const StockB = getLowestPriceStock(b);
          return parseInt(StockA.SellPrice) - parseInt(StockB.SellPrice);
        });
      } else if (this.sort_type == "時間由舊到新") {
        product_list = product_list.sort((a, b) => {
          return new Date(a.created_at) - new Date(b.created_at);
        });
      } else if (this.sort_type == "時間由新到舊") {
        product_list = product_list.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      }

      // 檢查this.productData中的資料將SellStatus!=normal的商品排到最後
      product_list = product_list.sort((a, b) => {
        if (a.SellStatus == "normal" && b.SellStatus != "normal") {
          return -1;
        }
        if (a.SellStatus != "normal" && b.SellStatus == "normal") {
          return 1;
        }
        return 0;
      });

      return product_list;
    },
    page_product_data() {
      const start_count = (this.page - 1) * 12;
      return getProductListData(
        this.sort_product_data.slice(start_count, start_count + 12)
      );
    },
    pagination_option() {
      return {
        per_page: 12,
        total: this.sort_product_data.length,
        total_pages: Math.ceil(this.sort_product_data.length / 12),
      };
    },
  },
  mounted() {
    this.CheckActiveCategory();
    this.CheckTimer();
  },
};
</script>
